const cacheAvailable = "caches" in self
const jsonContentType = "application/json"
const cacheName = "bd-cache-v1"
import config from "@common/config"
let baseUrl = config.apiurl


const get = async <T>(url: string) => {
    const req = createRequest(url, "get", jsonContentType)
    return await http<T>(req)
}

const createRequest = (url: string, method: string, contentType?: string, data?: any) => {
    const args: RequestInit = {
        method,
        headers: {
            "Content-Type": jsonContentType
        }
    }
        
    if (data) {
        if (contentType === jsonContentType)
            args.body = JSON.stringify(data)
        else
            args.body = data
    }
    
    const fullUrl = `${baseUrl}/${url}`
    return new Request(fullUrl, args)
}

async function http<T>(request: RequestInfo): Promise<T> {
    let errorFetchMsg
    let response: Response
    let cache: Cache
    if (cacheAvailable) {
        cache = await caches.open(cacheName)
        response = await cache.match(request)
        if (!response) {
            await cache.add(request)
            .catch((error) => {
                errorFetchMsg = "Error fetching"
                console.error(error.message)
                throw new Error(errorFetchMsg)
            })
            response = await cache.match(request)
        }
    }
    else {
        response = await fetch(request)
        .catch((error) => {
            errorFetchMsg = "Error fetching"
            console.error(error.message)
            throw new Error(errorFetchMsg)
        })
    }
    if (cacheAvailable)
        cacheControl(request as Request, response, cache)
    
    return resHandler(response)
}

const resHandler = async (res: Response) => {
    let errorFetchMsg
    if (res.ok) {
        const contentType = res.headers.get("content-type")
        if (res.status === 200 || res.status === 201) {
            
            if (contentType && contentType.includes("application/json")) {
                const json = await res.json()
                return json
            }
            const text = await res.text()
            return text
        }
        else {
            return ""
        }
    } else {
        console.error(`${res.statusText} (${res.status})`)
        
        errorFetchMsg = "Error fetching"
        if (res.status >= 400 && res.status < 500) {
            try {
                const pd = await res.json()
                console.log(pd)
                if (pd.title)
                    errorFetchMsg = pd.title
                else
                    errorFetchMsg = `status${res.status}`
            }
            catch (ex) {
                console.debug(ex)
            }
        } else {
            const message = await res.text()
            console.log(message)
        }
        
        throw new Error(errorFetchMsg)
    }
}

const cacheControl = async (req: Request, res: Response, cache: Cache) => {
    const date = res.headers.get("date")
    const dateCreated = new Date(date)
    console.log(`dateCreated=${dateCreated.toTimeString()}`)
    
    const dateInvalid = new Date(date)
    const hours = dateInvalid.getHours()
    dateInvalid.setHours(hours + 2)
    
    console.log(`dateInvalid=${dateInvalid.toTimeString()}`)
    const dateNow = new Date()
    
    console.log(`dateNow=${dateNow.toTimeString()}`)
    if (dateInvalid < dateNow) {
        console.log("invalidate!")
        await cache.add(req)
            .catch((error) => {
                console.error(error.message)
            })
    }
}

export default { get }
